import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/**
 * Action types & creators
 */
const { Types, Creators } = createActions({
  loadProfile: [],
  resetProfile: [],
  loadProfileSuccess: ['me', 'partner'],
  setPermissions: ['permissions'],
  setPartner: ['partner'],
  setPartners: ['partners']
});

export { Types };

export default Creators;

/**
 * Handlers
 */
const INITIAL_STATE = Immutable({
  loading: true,
  me: {
    id: '',
    name: '',
    email: '',
    type: '',
    permissions: []
  },
  partner: {
    id: '',
    name: '',
    document: '',
    zip: '',
    telephone: '',
    business_name: '',
    address: ''
  },
  partners: []
});

const loadProfileSuccess = (state, action) => ({
  ...state,
  loading: false,
  me: action.me,
  partner: action.partner
});

const setPartner = (state, action) => ({
  ...state,
  loading: false,
  partner: action.partner
});

const setPermissions = (state, action) => ({
  ...state,
  me: {
    ...state.me,
    permissions: action.permissions
  }
});

const resetProfile = (state, action) => INITIAL_STATE;

const setPartners = (state, action) => ({
  ...state,
  partners: action.partners
});

/**
 * Reducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.LOAD_PROFILE]: resetProfile,
  [Types.LOAD_PROFILE_SUCCESS]: loadProfileSuccess,
  [Types.SET_PERMISSIONS]: setPermissions,
  [Types.SET_PARTNER]: setPartner,
  [Types.RESET_PROFILE]: resetProfile,
  [Types.SET_PARTNERS]: setPartners
});
